const React = require('react');
const CancelablePromise = require('mn-utils/CancelablePromise');
const withState = require('../../../../utils/withState');
const WrapperWithLoading = require('../../../dumb/WrapperWithLoading');
const CheckboxA = require('../../../dumb/Checkbox/F');
const ButtonA = require('../../../dumb/Button/A');
const Rating = require('../../../dumb/Rating');


module.exports = withState((setState, self) => {
  function handleRestartOracle() {
    setState({
      loadingOracle: 1,
    });
    return CancelablePromise
        .delay(4000)
        .then(() => {
          setState({
            loadingOracle: 0,
          });
        });
  }
  function handleRestartNode() {
    setState({
      loadingNode: 1,
    });
    return CancelablePromise
        .delay(4000)
        .then(() => {
          setState({
            loadingNode: 0,
          });
        });
  }

  return (state, props) => {
    const data = props.data || {};
    return (
      <div className="layoutRow fhaS fvaC">
        <div className="w(|min)380 layoutRow fhaS fvaC">
          <WrapperWithLoading
            className="w180 pr11"
            loading={state.loading}
          >
            <CheckboxA
              checked={data.checked}
              label={data.name}
            />
          </WrapperWithLoading>
          <Rating value={70}/>
          <div
            className="ph15"
          >{data.time}</div>
        </div>
        <div className="layoutRow fhaS fvaC">
          <WrapperWithLoading
            loading={state.loadingOracle}
          >
            <ButtonA
              className="wmin100"
              onClick={handleRestartOracle}
            >Restart Oracle</ButtonA>
          </WrapperWithLoading>
          <WrapperWithLoading
            className="ml10"
            loading={state.loadingNode}
          >
            <ButtonA
              className="wmin100"
              onClick={handleRestartNode}
            >Restart Node</ButtonA>
          </WrapperWithLoading>
        </div>
      </div>
    );
  };
});
